import PropTypes from 'prop-types';
import React from 'react';

import { ReactComponent as Warning } from '../../assets/icons/warning.svg';
import { Modal } from './modal';

const WarningModal = ({ children, ...props }) => {
  return (
    <Modal Icon={Warning} {...props}>
      {children}
    </Modal>
  );
};

WarningModal.propTypes = {
  children: PropTypes.node
};

export { WarningModal };
